<template>
  <div>
    <div v-if="$slots.trigger" ref="triggerWrapper" class="bottom-sheet__trigger" @click="handleOpen">
      <slot name="trigger"></slot>
    </div>
    <div :id="sheetId" class="bottom-sheet" :class="sheetClass" data-test="bottom-sheet">
      <div class="bottom-sheet__overlay js-sheet-overlay" data-test="bottom-sheet-overlay"></div>
      <div
        class="bottom-sheet__content js-sheet-content"
        :class="{
          padding: hasContentPadding,
        }"
      >
        <div
          class="bottom-sheet__header"
          :class="{
            'bottom-sheet__header--empty': !title,
          }"
        >
          <div class="drag-icon js-drag-icon">
            <span class="icon-bar"></span>
          </div>
          <div class="bottom-sheet__header-content">
            <div v-if="title" class="title js-sheet-header">
              <span>{{ title }}</span>
            </div>
            <button
              class="btn-close js-bottom-sheet-close"
              aria-label="Close bottom sheet"
              data-bottom-sheet-close
              data-test="bottom-sheet-trigger-close"
            ></button>
          </div>
        </div>
        <div
          class="bottom-sheet__body js-sheet-body"
          :class="{
            'bottom-sheet__body--untitled': !title,
          }"
        >
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from 'vue'

import { createBottomSheet } from '../../../../shared/bottom_sheet/bottom_sheet'

const emit = defineEmits(['on-ready', 'on-close'])

const props = defineProps({
  sheetId: {
    type: String,
    required: true,
  },
  sheetClass: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  hasContentPadding: {
    type: Boolean,
    default: true,
  },
})

const sheetInstance = ref()

const triggerWrapper = ref(null)
const triggerButton = ref(null)

const getTriggerButton = () => {
  if (triggerWrapper.value) {
    return triggerWrapper.value.querySelector('button')
  }
  return null
}

function instantiateBottomSheet() {
  sheetInstance.value = createBottomSheet({
    sheetId: props.sheetId,
    showButton: triggerButton.value,
  })

  sheetInstance.value.addEventListener('close', () => {
    emit('on-close')
  })

  emit('on-ready', sheetInstance.value)
}

const handleOpen = () => {
  if (!sheetInstance.value) {
    instantiateBottomSheet()
  }
  sheetInstance.value.calcInitialSheetHeight()
  sheetInstance.value.show()
}

const handleClose = () => {
  sheetInstance.value.close()
}

watch(
  () => props.isOpen,
  isOpen => {
    if (isOpen) {
      handleOpen()
    } else {
      handleClose()
    }
  }
)

onMounted(() => {
  nextTick(() => {
    triggerButton.value = getTriggerButton()
    if (triggerButton.value) {
      instantiateBottomSheet()
    }
  })
})
</script>
